import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { LayoutService } from '../../services/layout.service';
import { NowPlayingService } from '../../services/now-playing.service';
import { SearchComponent } from '../search/search.component';

/**
 * Slim bar above the routed content: brand mark on compact viewports
 * (the sidebar carries it on desktop), the global search field, and the
 * "surprise me" shortcut.
 */
@Component({
  selector: 'topbar-component',
  standalone: true,
  imports: [RouterLink, MatIconModule, MatTooltipModule, SearchComponent],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent {
  protected readonly layout = inject(LayoutService);
  private readonly nowPlaying = inject(NowPlayingService);

  protected surpriseMe(): void {
    void this.nowPlaying.playRandom();
  }
}
